module.exports = __webpack_public_path__ + "static/img/编组 5备份 4.0eb7339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份 4.png
// module id = Nx7o
// module chunks = 1